<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Rubros de recaudación</h3>
            </div>
        </div>
        <h5>Valores de rubros</h5>
        <div v-if="recaudacion != null" class="table-responsive">
            <table>
                <tbody>
                    <tr>
                        <td><strong>Almuerzo</strong></td>
                        <td>
                            <div class="form-field">
                                <input-field id="almuerzo" v-model="form.almuerzo" placeholder="$ #,###.##" vMoney :format="money"></input-field>
                            </div>
                        </td>
                        <td><strong>Alquiler de vehículo</strong></td>
                        <td>
                             <div class="form-field">
                                <input-field id="pago_carro" v-model="form.pago_carro" placeholder="$ #,###.##" vMoney :format="money"></input-field>
                            </div>
                        </td>
                        <td><strong>Peaje</strong></td>
                        <td>
                            <div class="form-field">
                                <input-field id="peaje" v-model="form.peaje" placeholder="$ #,###.##" vMoney :format="money"></input-field>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Combustible</strong></td>
                        <td>
                            <div class="form-field">
                                <input-field id="gasolina" v-model="form.gasolina" placeholder="$ #,###.##" vMoney :format="money"></input-field>
                            </div>
                        </td>
                        <td><strong>Depósito</strong></td>
                        <td>
                            <div class="form-field">
                                <input-field id="deposito" v-model="form.deposito" placeholder="$ #,###.##" vMoney :format="money"></input-field>
                            </div>
                        </td>
                        <td><strong>Otros</strong></td>
                        <td>
                            <div class="form-field">
                                <input-field id="otros" v-model="form.otros" placeholder="$ #,###.##" vMoney :format="money"></input-field>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Total:</strong></td>
                        <td>{{ moneyFormat(totalRubros) }}</td>
                        <td><strong>Observaciones:</strong></td>
                        <td colspan="3">
                            <div class="form-field">
                                <textarea-field
                                    id="observacion_otros"
                                    placeholder="Escriba..."                    
                                    v-model="form.observacion_otros"
                                >
                                </textarea-field>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <h5>Galería</h5>
        <div v-if="recaudacion != null" class="row">
            <div class="col-xs-12 col-md-3">
                <h5>Almuerzo</h5>
                <image-uploader v-model="form.foto_almuerzo" id="foto_almuerzo"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Alquiler de vehículo</h5>
                <image-uploader v-model="form.foto_pago_carro" id="foto_pago_carro"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Peaje</h5>
                <image-uploader v-model="form.foto_peaje" id="foto_peaje"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Combustible</h5>
                <image-uploader v-model="form.foto_gasolina" id="foto_gasolina"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Combustible 2</h5>
                <image-uploader v-model="form.foto_gasolina2" id="foto_gasolina2"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Combustible 3</h5>
                <image-uploader v-model="form.foto_gasolina3" id="foto_gasolina3"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Combustible 4</h5>
                <image-uploader v-model="form.foto_gasolina4" id="foto_gasolina4"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Otros</h5>
                <image-uploader v-model="form.foto_otros" id="foto_otros"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Otros 2</h5>
                <image-uploader v-model="form.foto_otros2" id="foto_otros2"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Otros 3</h5>
                <image-uploader v-model="form.foto_otros3" id="foto_otros3"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Otros 4</h5>
                <image-uploader v-model="form.foto_otros4" id="foto_otros4"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Depósito</h5>
                <image-uploader v-model="form.foto_deposito" id="foto_deposito"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Depósito 2</h5>
                <image-uploader v-model="form.foto_deposito2" id="foto_deposito2"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Depósito 3</h5>
                <image-uploader v-model="form.foto_deposito3" id="foto_deposito3"></image-uploader>
            </div>
            <div class="col-xs-12 col-md-3">
                <h5>Depósito 4</h5>
                <image-uploader v-model="form.foto_deposito4" id="foto_deposito4"></image-uploader>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="actualizar" class="btn-success"><i class="fa fa-save"></i><span>Actualizar</span></button>
            <button type="button" @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
import ImageUploader from '../visitas/ImageUploader.vue';
export default {
    computed: {
        totalRubros: function () {
            let almuerzo = parseFloat(this.form.almuerzo);
            if (isNaN(almuerzo))
                almuerzo = 0;
            let pago_carro = parseFloat(this.form.pago_carro);
            if (isNaN(pago_carro))
                pago_carro = 0;
            let peaje = parseFloat(this.form.peaje);
            if (isNaN(peaje))
                peaje = 0;
            let gasolina = parseFloat(this.form.gasolina);
            if (isNaN(gasolina))
                gasolina = 0;
            let deposito = parseFloat(this.form.deposito);
            if (isNaN(deposito))
                deposito = 0;
            let otros = parseFloat(this.form.otros);
            if (isNaN(otros))
                otros = 0;
            return round(almuerzo + pago_carro + peaje + gasolina + deposito + otros, 2);
        }
    },
    components: {
        ImageUploader
    },
    data: function () {
        return {
            moneyFormat: moneyFormat,
            money: money,
            recaudacion: null,
            form: {
                almuerzo: 0,
                pago_carro: 0,
                peaje: 0,
                gasolina: 0,
                otros: 0,
                foto_almuerzo: null,
                foto_pago_carro: '',
                foto_peaje: '',
                foto_gasolina: '',
                foto_gasolina2: '',
                foto_gasolina3: '',
                foto_gasolina4: '',
                foto_otros: '',
                foto_otros2: '',
                foto_otros3: '',
                foto_otros4: '',
                foto_deposito: '',
                foto_deposito2: '',
                foto_deposito3: '',
                foto_deposito4: '',
                deposito: 0,
                observacion_otros: ''
            }
        };
    },
    props: {
        recaudacionId: {
            type: String,
            required: true
        }
    },
    methods: {
        actualizar: function () {
            axios({
                method: 'POST',
                url: url + '/actualizar-rubros-recaudacion/' + this.recaudacionId,
                data: this.$objectToFD(this.form),
                headers: { "Content-Type": "multipart/form-data" }
            }).then(() => {
                swal('Los rubros de la recaudación fueron actualizados exitósamente.', 'Realizado', 'success');
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        cargarRubros: function () {
            axios.get(url + '/rubros/' + this.recaudacionId).then(({data}) => {
                this.recaudacion = data;
                this.form.almuerzo = data.almuerzo;
                this.form.pago_carro = data.pago_carro;
                this.form.peaje = data.peaje;
                this.form.gasolina = data.gasolina;
                this.form.otros = data.otros;
                this.form.deposito = data.deposito;
                this.form.observacion_otros = data.observacion_otros;
                if (data.foto_almuerzo != null) {
                    let foto_almuerzo = url + '/storage/' + data.foto_almuerzo;
                    let filename = foto_almuerzo.substring(foto_almuerzo.lastIndexOf('/')+1);
                    fetch(foto_almuerzo).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_almuerzo = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_pago_carro != null) {
                    let foto_pago_carro = url + '/storage/' + data.foto_pago_carro;
                    let filename = foto_pago_carro.substring(foto_pago_carro.lastIndexOf('/')+1);
                    fetch(foto_pago_carro).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_pago_carro = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_peaje != null) {
                    let foto_peaje = url + '/storage/' + data.foto_peaje;
                    let filename = foto_peaje.substring(foto_peaje.lastIndexOf('/')+1);
                    fetch(foto_peaje).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_peaje = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_gasolina != null) {
                    let foto_gasolina = url + '/storage/' + data.foto_gasolina;
                    let filename = foto_gasolina.substring(foto_gasolina.lastIndexOf('/')+1);
                    fetch(foto_gasolina).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_gasolina = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_gasolina2 != null) {
                    let foto_gasolina2 = url + '/storage/' + data.foto_gasolina2;
                    let filename = foto_gasolina2.substring(foto_gasolina2.lastIndexOf('/')+1);
                    fetch(foto_gasolina2).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_gasolina2 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_gasolina3 != null) {
                    let foto_gasolina3 = url + '/storage/' + data.foto_gasolina3;
                    let filename = foto_gasolina3.substring(foto_gasolina3.lastIndexOf('/')+1);
                    fetch(foto_gasolina3).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_gasolina3 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_gasolina4 != null) {
                    let foto_gasolina4 = url + '/storage/' + data.foto_gasolina4;
                    let filename = foto_gasolina4.substring(foto_gasolina4.lastIndexOf('/')+1);
                    fetch(foto_gasolina4).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_gasolina4 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_otros != null) {
                    let foto_otros = url + '/storage/' + data.foto_otros;
                    let filename = foto_otros.substring(foto_otros.lastIndexOf('/')+1);
                    fetch(foto_otros).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_otros = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_otros2 != null) {
                    let foto_otros2 = url + '/storage/' + data.foto_otros2;
                    let filename = foto_otros2.substring(foto_otros2.lastIndexOf('/')+1);
                    fetch(foto_otros2).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_otros2 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_otros3 != null) {
                    let foto_otros3 = url + '/storage/' + data.foto_otros3;
                    let filename = foto_otros3.substring(foto_otros3.lastIndexOf('/')+1);
                    fetch(foto_otros3).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_otros3 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_otros4 != null) {
                    let foto_otros4 = url + '/storage/' + data.foto_otros4;
                    let filename = foto_otros4.substring(foto_otros4.lastIndexOf('/')+1);
                    fetch(foto_otros4).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_otros4 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_deposito != null) {
                    let foto_deposito = url + '/storage/' + data.foto_deposito;
                    let filename = foto_deposito.substring(foto_deposito.lastIndexOf('/')+1);
                    fetch(foto_deposito).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_deposito = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_deposito2 != null) {
                    let foto_deposito2 = url + '/storage/' + data.foto_deposito2;
                    let filename = foto_deposito2.substring(foto_deposito2.lastIndexOf('/')+1);
                    fetch(foto_deposito2).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_deposito2 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_deposito3 != null) {
                    let foto_deposito3 = url + '/storage/' + data.foto_deposito3;
                    let filename = foto_deposito3.substring(foto_deposito3.lastIndexOf('/')+1);
                    fetch(foto_deposito3).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_deposito3 = new File([blob], filename, {type: blob.type});
                    });
                }
                if (data.foto_deposito4 != null) {
                    let foto_deposito4 = url + '/storage/' + data.foto_deposito4;
                    let filename = foto_deposito4.substring(foto_deposito4.lastIndexOf('/')+1);
                    fetch(foto_deposito4).then(res => res.blob())
                    .then(blob => {
                        this.form.foto_deposito4 = new File([blob], filename, {type: blob.type});
                    });
                }
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        }
    },
    mounted: function () {
        this.cargarRubros();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/RubrosRecaudacion.vue